<ng-container *ngIf="datum">
  <div *ngIf="showTextbox">
    <div class="ols-textbox ols-textbox-date">
      <input dateInput [(ngModel)]="tekst" placeholder="{{placeholder}}" (keyup)="onKey($event)"
        (focus)='setTextFocus(true)' (blur)='setTextFocus(false)'>
      <div class="icon-cal ial-fu_003" (click)="toggleCalendar()"></div>
    </div>
    <p class="error-block" *ngIf="!validDate && !isTextLeeg() && textHadFocus">{{errormessageText}}</p>
    <p class="error-block" *ngIf="validDate && validatieError">{{errormessageValidatie}}</p>
    <p class="error-block" *ngIf="submitClicked && isTextLeeg()">Kies alsjeblieft een datum</p>
  </div>
  <div *ngIf="calOpen">
    <input type="text" class="input dp" appDatepicker [mindate]="minDatum" [maxdate]="maxDatum" [open]=true
      [closeOnSelect]="calCloseOnSelect" [startDate]="datum" [showPrevNext]="showPrevNext" [meetId]="meetId" [(ngModel)]="datum" />
  </div>
</ng-container>